let slider;
let thumbnails;

export function renderSponsoredSlider(slides = []) {
    const section = document.getElementById('sponsored-restaurants');
    if (!section) return;

    slider?.destroy(true, true);
    thumbnails?.destroy(true, true);
    slider = thumbnails = null;

    const mainWrapper = section.querySelector('.sponsored-slides .swiper-wrapper');
    const thumbsWrapper = section.querySelector('.sponsored-thumbs .swiper-wrapper');
    mainWrapper.replaceChildren();
    thumbsWrapper.replaceChildren();
    section.hidden = slides.length === 0;
    if (section.hidden) return;

    slides.forEach((slide, index) => {
        const card = section.querySelector('.sponsored-slide-template').content.cloneNode(true);
        card.querySelector('a').href = slide.url;
        const image = card.querySelector('img');
        image.src = slide.image;
        image.loading = index === 0 ? 'eager' : 'lazy';
        card.querySelector('.sponsored-name').textContent = slide.name;
        card.querySelector('.sponsored-location').textContent = slide.location || '';
        card.querySelector('.sponsored-location-wrap').hidden = !slide.location;
        const rating = card.querySelector('.sponsored-rating');
        rating.hidden = !slide.rating_html;
        rating.innerHTML = slide.rating_html || '';
        const cuisines = card.querySelector('.sponsored-cuisines');
        cuisines.textContent = slide.cuisines || '';
        cuisines.hidden = !slide.cuisines;
        card.querySelector('.sponsored-details').textContent = slide.motto || '';
        mainWrapper.append(card);

        const thumb = section.querySelector('.sponsored-thumb-template').content.cloneNode(true);
        thumb.querySelector('img').src = slide.image;
        thumb.querySelector('button').setAttribute('aria-label', slide.name);
        thumb.querySelector('button').addEventListener('focus', () => thumbnails?.slideTo(index));
        thumb.querySelector('button').addEventListener('click', () => slider.slideToLoop(index));
        thumbsWrapper.append(thumb);
    });

    const multiple = slides.length > 1;
    section.style.setProperty('--sponsored-thumb-count', slides.length);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const progress = section.querySelector('.sponsored-progress-fill');
    section.classList.toggle('has-multiple', multiple);
    section.classList.remove('is-playing');
    section.querySelector('.sponsored-thumbs').hidden = !multiple;
    section.querySelector('.sponsored-progress').hidden = !multiple;
    const delay = 5000;
    let remaining = delay;
    let startedAt = 0;
    let timer = null;
    if (multiple) {
        thumbnails = new Swiper(section.querySelector('.sponsored-thumbs'), {
            slidesPerView: 'auto',
            spaceBetween: 8,
            watchOverflow: true,
        });
    }

    function syncAutoplay(swiper) {
        if (!swiper || swiper.destroyed || !multiple) return;
        const hovered = window.matchMedia('(hover: hover)').matches && section.matches(':hover');
        const paused = reducedMotion || hovered || document.hidden || section.contains(document.activeElement);
        if (paused && timer !== null) {
            remaining = Math.max(0, remaining - (performance.now() - startedAt));
            clearTimeout(timer);
            timer = null;
        } else if (!paused && timer === null) {
            startedAt = performance.now();
            timer = setTimeout(() => {
                timer = null;
                swiper.slideNext();
            }, remaining);
        }
        section.classList.toggle('is-playing', !paused);
    }

    function updateActiveSlide(swiper) {
        const activeIndex = swiper.realIndex;
        section.querySelectorAll('.sponsored-thumb').forEach((button, index) => {
            button.setAttribute('aria-pressed', String(index === activeIndex));
        });
        Array.from(swiper.slides).forEach((slide, index) => {
            slide.setAttribute('aria-hidden', String(index !== swiper.activeIndex));
            slide.querySelector('a').tabIndex = index === swiper.activeIndex ? 0 : -1;
        });
        if (thumbnails) {
            const rail = thumbnails.el.getBoundingClientRect();
            const thumb = thumbnails.slides[activeIndex].getBoundingClientRect();
            const outside = thumbnails.isVertical()
                ? thumb.top < rail.top || thumb.bottom > rail.bottom
                : thumb.left < rail.left || thumb.right > rail.right;
            if (outside) thumbnails.slideTo(activeIndex);
        }
        // Restart the five-second indicator when navigation starts a new slide.
        clearTimeout(timer);
        timer = null;
        remaining = delay;
        progress.style.animation = 'none';
        void progress.offsetWidth;
        progress.style.animation = '';
        syncAutoplay(swiper);
    }

    const onVisibilityChange = () => syncAutoplay(slider);
    slider = new Swiper(section.querySelector('.sponsored-slides'), {
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: {crossFade: true},
        loop: multiple,
        watchOverflow: true,
        speed: reducedMotion ? 0 : 650,
        on: {
            init: updateActiveSlide,
            slideChange: updateActiveSlide,
            destroy: () => {
                clearTimeout(timer);
                document.removeEventListener('visibilitychange', onVisibilityChange);
            },
        },
    });
    document.addEventListener('visibilitychange', onVisibilityChange);
    section.onmouseenter = () => syncAutoplay(slider);
    section.onmouseleave = () => syncAutoplay(slider);
    section.onfocusin = () => syncAutoplay(slider);
    section.onfocusout = () => queueMicrotask(() => syncAutoplay(slider));
}
